<template>
    <div class="signIn" id="barId">
        <div class="text1">申请报名吉林一号遥感开发者培训班</div>
        <div class="white">
            <div class="text3">恭喜！</div>
            <div class="text4">您已成功提交报名申请，请耐心等待审核~</div>
            <div class="buttonGroup">
                <div class="btnHome" @click="$router.push('/');">返回首页</div>
                <div class="btnOther" @click="$router.push('/offlineSignIn');">报名其他站</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
      name: "offlineSignInResult",
      data() {
        return {
          weChatLink:''
        };
      },
      methods: {
        getKey() {
          return localStorage.getItem("token");
        },
        getCampList(){
          this.axios.get("/learn_back/course/register/getCampList", {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            this.trainCampList=res.data.data.trainCampList
           this.weChatLink=res.data.data.weChatLink
          })
        },
      },
    
      mounted() {
        document.getElementById('barId').scrollIntoView({ behavior: "instant"});
        this.getCampList()
      },
      created(){
      }
    };
</script>
<style scoped>
    .signIn {
  position: relative;
  width: 100%;
  height: 100%;
  background: #f5f5f6;
}
.text1 {
  position: absolute;
  top: 174px;
  left: calc(50% - 208px);
  width: 416px;
  height: 31px;
  font-size: 26px;
  font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
  font-weight: normal;
  color: #3a3a3a;
  line-height: 31px;
  text-align: center;
}
.white {
  position: absolute;
  top: 259px;
  left: calc(50% - 640px);
  width: 1280px;
  height: 600px;
  background: #ffffff;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
}
.text2{
    position: absolute;
    top: 119px;
    left: calc(50% - 160px);
    width: 320px;
height: 28px;
font-size: 20px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 28px;
text-align: center;

}
.homeBack{
    position: absolute;
    top:500px;
    left: calc(50% - 75px);
    width: 150px;
height: 44px;
background: #C49760;
border-radius: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 44px;
text-align: center;
cursor: pointer;
}
.text3{
    position: absolute;
    top: 67px;
    left: calc(50% - 100px);
    width: 200px;
height: 37px;
font-size: 26px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 37px;
text-align: center;
}
.text4{
    position: absolute;
    top: 136px;
    left: calc(50% - 400px);
    width: 800px;
height: 64px;
font-size: 18px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 32px;
text-align: center;
}
.erweima{
  position: absolute;
  width: 200px;
  top: 190px;
  left: calc(50% - 100px);
}
.buttonGroup{
    position: absolute;
    top: 500px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 20px;
}
.btnHome{
    width: 150px;
    height: 44px;
    background: #C49760;
    border-radius: 22px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
}
.btnOther{
    width: 150px;
    height: 44px;
    background: #FFFFFF;
    border: 1px solid #C49760;
    border-radius: 22px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #C49760;
    line-height: 42px;
    text-align: center;
    cursor: pointer;
}
</style>